import { inject, Pipe, PipeTransform } from '@angular/core';
import { NumberSeparatorUtilitiesService } from '@utilities/number-separator-utilities.service';

@Pipe({
  name: 'numberLocale',
})
export class NumberLocalePipe implements PipeTransform {
  private readonly numberSeparatorUtilities = inject(NumberSeparatorUtilitiesService);

  public transform(value: number | null | undefined, isPercentage = false): string {
    if (value === null || value === undefined) {
      return '—';
    }

    if (isPercentage) {
      return `${this.numberSeparatorUtilities.formatNumberToLocaleString(value * 100, undefined, 0, 2)}%`;
    }

    return this.numberSeparatorUtilities.formatNumberToLocaleString(value, undefined, 0, 2, true);
  }
}
